import { FieldValues, Control, Path } from 'react-hook-form';
import * as React from 'react';
import { JSX } from 'react';

import { FormControl, FormMessage, FormField, FormLabel, FormItem } from '.';
import { Checkbox } from '../checkbox/checkbox';
import { cn } from '../../utils';

export type CheckboxData<T> = {
  label: JSX.Element | string;
  required?: boolean;
  name: Path<T>;
  id?: string;
}[];

interface IFormRadioGroupProps<T extends FieldValues = FieldValues> {
  componentProps?: Partial<React.ComponentProps<typeof Checkbox>>;
  hideErrorMessage?: boolean;
  formControl: Control<T>;
  items: CheckboxData<T>;
  className?: string;
}

export function FormCheckboxGroup<T extends FieldValues>({
  hideErrorMessage,
  componentProps,
  formControl,
  className,
  items,
}: IFormRadioGroupProps<T>) {
  return (
    <>
      {items.map((item) => (
        <FormField
          render={({ field, formState }) => {
            const hasError = formState.errors[field.name];

            return (
              <FormItem key={item.name}>
                <div
                  className={cn('flex flex-row items-start space-x-3 space-y-0 mb-2', className)}
                >
                  <FormControl>
                    <Checkbox
                      {...componentProps}
                      onCheckedChange={field.onChange}
                      id={item.id ?? item.name}
                      checked={field.value}
                      hasError={!!hasError}
                    />
                  </FormControl>
                  <FormLabel
                    htmlFor={item.id ?? item.name}
                    required={item.required}
                    className="font-normal"
                  >
                    {item.label}
                  </FormLabel>
                </div>
                {!hideErrorMessage && <FormMessage />}
              </FormItem>
            );
          }}
          control={formControl}
          name={item.name}
          key={item.name}
        />
      ))}
    </>
  );
}
